var _path, _path2, _rect, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertYellowGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9593 16.75L17.0311 4.75C15.6839 2.41667 12.3161 2.41667 10.9689 4.75L4.04071 16.75C2.69356 19.0833 4.37749 22 7.07179 22H20.9282C23.6225 22 25.3064 19.0833 23.9593 16.75Z",
    fill: "url(#paint0_linear_843_1481)",
    stroke: "#B47700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.1651 5.25L23.0933 17.25C24.0555 18.9167 22.8527 21 20.9282 21H7.07179C5.14729 21 3.94448 18.9167 4.90673 17.25L11.8349 5.25C12.7972 3.58333 15.2028 3.58333 16.1651 5.25Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2194,
    y: 14.2051,
    width: 2.41161,
    height: 6.47934,
    rx: 1.20581,
    transform: "rotate(-180 15.2194 14.2051)",
    fill: "#5A3C00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0136,
    cy: 17.0606,
    rx: 1.20581,
    ry: 1.20581,
    transform: "rotate(-180 14.0136 17.0606)",
    fill: "#5A3C00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_843_1481",
    x1: 8.35821,
    y1: 4.6791,
    x2: 19.5025,
    y2: 23.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A91C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertYellowGradient);
export default __webpack_public_path__ + "static/media/alert-yellow-gradient.b5e20855.svg";
export { ForwardRef as ReactComponent };